export const alphabet = 'abcdefghijklmnopqrstuvwxyz';
export const digits = '0123456789';
